import { Grid, ThemeProvider, createTheme, Typography, Box } from "@mui/material";
import { grey } from "@mui/material/colors";
import React, { useState } from "react";
import DNSHealthCard from "../../components/dashboard/DNSHealthCard";
import SessionsTimelineCard from "../../components/dashboard/SessionsTimelineCard";
import AuthTimelineCard from "../../components/dashboard/AuthTimelineCard";
import TopUsersCard from "../../components/dashboard/TopUsersCard";
import BlockedDomainsCard from "../../components/dashboard/BlockedDomainsCard";
import ExpiringCategoriesCard from "../../components/dashboard/ExpiringCategoriesCard";
import TopCategoriesCard from "../../components/dashboard/TopCategoriesCard";
import SyslogVolumeCard from "../../components/dashboard/SyslogVolumeCard";
import CountersFooter from "../../components/dashboard/CountersFooter";
import RangePicker from "../../components/dashboard/RangePicker";
import { useAuth } from "../../components/AuthProvider";

export default function Dashboard() {
    const auth = useAuth();
    const [range, setRange] = useState(() => {
        try { return localStorage.getItem("dashboard.range") || "24h"; } catch { return "24h"; }
    });
    const handleRange = (v) => {
        setRange(v);
        try { localStorage.setItem("dashboard.range", v); } catch {}
    };

    const theme = createTheme({
        palette: {
            primary: { main: "#e01b29" },
            secondary: { main: grey[900] },
        },
    });

    React.useEffect(() => {
        document.title = "IPV7 Tools - Dashboard";
    }, []);

    const canSessions = auth.hasPerm("log_session.get_all");
    const canAuthFail = auth.hasPerm("log_fail.get_all");
    const canAccess = auth.hasPerm("access.get_all");
    const canDnsNode = auth.hasPerm("dns_node.get_all");
    const canBlacklist = auth.hasPerm("dns_blacklist.get_all");
    const canSyslog = auth.hasPerm("pegeia.get_all");

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ p: 2, pb: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1, flexWrap: 'wrap', gap: 2 }}>
                    <Typography variant="h5" sx={{ fontWeight: 600, color: 'text.primary' }}>
                        Visão geral
                    </Typography>
                    <RangePicker value={range} onChange={handleRange} />
                </Box>
            </Box>

            {/* === SEÇÃO RADIUS === */}
            <Box sx={{ px: 2, pt: 1 }}>
                <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                    RADIUS / Gate
                </Typography>
            </Box>
            <Grid container>
                {canDnsNode && (
                    <Grid item xs={12} md={6} lg={3}>
                        <DNSHealthCard />
                    </Grid>
                )}
                {canAccess && (
                    <Grid item xs={12} md={6} lg={3}>
                        <TopUsersCard range={range} />
                    </Grid>
                )}
                {canSessions && (
                    <Grid item xs={12} lg={6}>
                        <SessionsTimelineCard range={range} />
                    </Grid>
                )}
            </Grid>

            {(canSessions || canAuthFail) && (
                <Grid container>
                    <Grid item xs={12}>
                        <AuthTimelineCard range={range} />
                    </Grid>
                </Grid>
            )}

            {/* === SEÇÃO DNS === */}
            {canBlacklist && (
                <>
                    <Box sx={{ px: 2, pt: 2 }}>
                        <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                            DNS / Blacklist
                        </Typography>
                    </Box>
                    <Grid container>
                        <Grid item xs={12} md={6} lg={4}>
                            <BlockedDomainsCard />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <ExpiringCategoriesCard days={30} />
                        </Grid>
                        <Grid item xs={12} lg={4}>
                            <TopCategoriesCard />
                        </Grid>
                    </Grid>
                </>
            )}

            {/* === SEÇÃO SYSLOG === */}
            {canSyslog && (
                <>
                    <Box sx={{ px: 2, pt: 2 }}>
                        <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                            Syslog
                        </Typography>
                    </Box>
                    <Grid container>
                        <Grid item xs={12}>
                            <SyslogVolumeCard range={range} />
                        </Grid>
                    </Grid>
                </>
            )}

            {/* === FOOTER COMPACTO === */}
            <CountersFooter />
        </ThemeProvider>
    );
}
